import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import getDefaultValues from '../../../admin-on-rest/src/mui/form/getDefaultValues';
import { CardTitle } from 'material-ui/Card';
import ContentSave from 'material-ui/svg-icons/content/save';
import FlatButton from 'material-ui/FlatButton';

import {Toolbar, ToolbarGroup} from "material-ui/Toolbar";

import {
	translate,
	Title,
	email,
	CREATE,
	showNotification as showNotificationAction,
  refreshView as refreshViewAction
} from "admin-on-rest";

import {giftCardSimpleForm} from "./style";

import RadioButtonGroupInput from "./RadioButtonGroupInput";
import FormInput from "./FormInput";

import {validatePhone} from "./validations";

import restClient from "../../../restClient";

import TextInput from "../TextInput";
import PhoneNumberInput from "../PhoneNumberInput";

import {BMTheme} from "../../../BMTheme";


export class SimpleForm extends Component {
	state = {
		disabledInputFields: false,
		date: null,
		kiosk_id: null
	};	

	componentDidMount() {
		let d = new Date();
		let dateString = d.getUTCDate() +"/"+ (d.getUTCMonth()+1) +"/"+ d.getUTCFullYear();
		this.setState({ date: dateString });

		const kiosk = JSON.parse(localStorage.getItem("kiosk"));
    const kiosk_id = kiosk ? kiosk.id : '';
		this.setState({ kiosk_id: kiosk_id });

		const {
			refreshView
		} = this.props;
		refreshView();
	}

	handleSubmit(values) {
		values.kiosk_id = this.state.kiosk_id;

		if(this.props.userChecked){
			if(this.props.existingCustomer){
				this.props.save(values, 'edit');
			} else {
				const {showNotification} = this.props;
				const customerData = {
					first_name: values.first_name,
					last_name: values.last_name,
					email: values.email,
					phone: values.phone,
					older_than_18: true,
					promo_id: values.promo_id,
					kiosk_id: this.state.kiosk_id
				}
				restClient(CREATE, 'customers', {
					data: customerData
				}).then(response => {
					var customerID = response.data.id;
					values.customer_id = customerID;
					this.props.save(values, 'edit');
				}).catch(error => {
					showNotification(this.props.translate("resources.giftCards.customerCreateError"), "warning");
					console.debug(error);
				});
			}
		} else {
			const {showNotification} = this.props;
			showNotification(this.props.translate("resources.giftCards.customerNotChecked"), "warning");
		}
		
		
	}

	render() {
		const {
			basePath,
			record,
			resource,
			giftCardForm,
			disabledInputFields,
			checkCustomer,
			inputPhoneNumberChange,
			title,
			kioskPromos,
			existingCustomer,
			showEmptyFields,
			translate,
			valid,
			userChecked
		} = this.props;
		
		var textInputs = existingCustomer ? [
			<TextInput
				label="resources.storeOwners.inputs.firstName"
				source="first_name"
				style={giftCardForm.inputStyle}
				disabled={disabledInputFields}
				required
			/>,
			<TextInput
				label="resources.storeOwners.inputs.lastName"
				source="last_name"
				style={giftCardForm.inputStyle}
				disabled={disabledInputFields}
				required
			/>,
			<TextInput
				label="resources.storeOwners.inputs.email"
				source="email"
				type="email"
				validate={email}
				style={giftCardForm.inputStyle}
				disabled={disabledInputFields}
			/>
		] : [];

		var emptyTextInputs = [
			<TextInput
				label="resources.storeOwners.inputs.firstName"
				source="first_name"
				style={giftCardForm.inputStyle}
				disabled={disabledInputFields}
				required
			/>,
			<TextInput
				label="resources.storeOwners.inputs.lastName"
				source="last_name"
				style={giftCardForm.inputStyle}
				disabled={disabledInputFields}
				required
			/>,
			<TextInput
				label="resources.storeOwners.inputs.email"
				source="email"
				type="email"
				validate={email}
				style={giftCardForm.inputStyle}
				disabled={disabledInputFields}
			/>
		];

		const radioButtonsGroupStyle = {
			padding: 0,
			margin: 0
		};
		var promosRadioGroup = kioskPromos ? [
			<RadioButtonGroupInput disabled={!valid || !userChecked} label="Promo" source="promo_id" choices={kioskPromos} elStyle={radioButtonsGroupStyle} />
		] : null;
		
		var valuesRadioGroup = [
			<RadioButtonGroupInput disabled={!valid || !userChecked} label="Value" elStyle={radioButtonsGroupStyle} source="value" choices={[
				{ id: 10000, name: "100,00" },
				{ id: 25000, name: "250,00" },
				{ id: 50000, name: "500,00" },
				{ id: 100000, name: "1000,00" },
				{ id: 200000, name: "2000,00" }
			]} />
		];

		const titleElement = (
			<Title title={title} defaultTitle="" />
		);
		const radioButtonsPromosTitleElement = (
			<Title title={translate("resources.giftCards.promosLabel")} defaultTitle="" />
		);
		const radioButtonsValuesTitleElement = (
			<Title title={translate("resources.giftCards.valuesLabel")} defaultTitle="" />
		);
		
		const titleStyle = {
			borderBottom: "3px solid #E7E7E7"
		}

		const dialCountry = {SE: "SE"};

		const phoneInput = <PhoneNumberInput
			label="resources.stores.inputs.phoneNumber"
			source="phone"
			validate={validatePhone}
			onChange={inputPhoneNumberChange}
			style={giftCardForm.inputStyle}
			dialCountry={dialCountry.SE}
		/>;

		return (
			<React.Fragment>
				
				<form onSubmit={this.props.handleSubmit(this.handleSubmit.bind(this))} className="simple-form gift-card-form">
					
						<div style={giftCardSimpleForm.inputsContainer} className="person-inputs-container">
							<CardTitle title={titleElement} className="title" style={titleStyle} />
							
							<div style={giftCardSimpleForm.customerFieldsContainer}>
								<FormInput
									basePath={basePath}
									input={phoneInput}
									record={record}
									resource={resource}
								/>
								<FlatButton
									primary
									label={translate("resources.giftCards.checkCustomerButton")}
									style={giftCardForm.checkButton}
									onClick={checkCustomer}
									backgroundColor="#969696"
									hoverColor="#969696"
									disabled={!valid}
								/>
								<div style={giftCardForm.clearFloatContainer} />
							</div>
							

							<div style={giftCardSimpleForm.customerFieldsContainer}>
								{existingCustomer && textInputs.map(
									(input, index) => {
										return <FormInput
											key={index}
											basePath={basePath}
											input={input}
											record={record}
											resource={resource}
										/>;
									}
								)}

								{showEmptyFields && emptyTextInputs.map(
									(input, index) => {
										return <FormInput
											key={index}
											basePath={basePath}
											input={input}
											record={record}
											resource={resource}
										/>;
									}
								)}

								<div style={giftCardForm.clearFloatContainer} />
							</div>
							
							
						</div>
						
						<div 
							style={
								{
									...giftCardSimpleForm.inputsContainerNoMargin, 
									borderTop: "5px solid", 
									borderColor: BMTheme.palette.primary1Color, 
									borderTopLeftRadius: "3px", 
									borderTopRightRadius: "3px"
								}} 
							className="person-inputs-container"
						>
							
							<div style={giftCardSimpleForm.radioButtonsContainer}>
								<CardTitle 
									title={radioButtonsPromosTitleElement} 
									className="title" 
									style={{
										...titleStyle,
										padding: 10,
										borderRight: "1px solid #E7E7E7"
									}} 
								/>
								{kioskPromos ? promosRadioGroup.map(
									(input, index) => {
										return <FormInput
											key={index}
											basePath={basePath}
											input={input}
											record={record}
											resource={resource}
										/>;
									}
								): null}
							</div>
							
							<div style={giftCardSimpleForm.radioButtonsContainer}>
								<CardTitle 
									title={radioButtonsValuesTitleElement} 
									className="title" 
									style={{
										...titleStyle,
										padding: 10,
										borderLeft: "1px solid #E7E7E7"
									}} 
								/>
								
								{valuesRadioGroup.map(
									(input, index) => {
										return <FormInput
											key={index}
											basePath={basePath}
											input={input}
											record={record}
											resource={resource}
										/>;
									}
								)}
							</div>
							<div style={giftCardForm.clearFloatContainer} />

							<Toolbar style={{ justifyContent: "flex-end" }}>
								<ToolbarGroup>
									<FlatButton
										type="submit"
										label={translate("resources.giftCards.saveButton")}
										icon={<ContentSave />}
										primary
										style={giftCardSimpleForm.giftCardButton}
									/>
								</ToolbarGroup>						
							</Toolbar>

						</div>
				</form>
			
			</React.Fragment>
		);
	}
}

SimpleForm.propTypes = {
	basePath: PropTypes.string,
	children: PropTypes.node,
	defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
	handleSubmit: PropTypes.func, // passed by redux-form
	invalid: PropTypes.bool,
	record: PropTypes.object,
	resource: PropTypes.string,
	redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	save: PropTypes.func, // the handler defined in the parent, which triggers the REST submission
	submitOnEnter: PropTypes.bool,
	toolbar: PropTypes.element,
	translate: PropTypes.func,
	validate: PropTypes.func,
	version: PropTypes.number,
};

SimpleForm.defaultProps = {
	submitOnEnter: true,
	toolbar: <Toolbar />,
};

const enhance = compose(
	connect((state, props) => ({
		initialValues: getDefaultValues(state, props),
	}),
	{
    showNotification: showNotificationAction,
		refreshView: refreshViewAction
  }),
	translate,
	reduxForm({
		form: 'record-create-form',
		enableReinitialize: true,
	})
);

export default enhance(SimpleForm);



// WEBPACK FOOTER //
// ./src/components/CRM/Form/SimpleCreateGiftCardForm.js